/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_UsersInputs */

const da_admin_nav_users = /** @type {(inputs: Admin_Nav_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brugere`)
};

/** @type {(inputs: Admin_Nav_UsersInputs) => LocalizedString} */
const en_admin_nav_users = da_admin_nav_users;

/**

* @param {Admin_Nav_UsersInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const admin_nav_users = /** @type {((inputs?: Admin_Nav_UsersInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_UsersInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_users(inputs)
	return /** @type {LocalizedString} */ ("Brugere")
});